export default __webpack_public_path__ + "assets/community-one-one-small.4d02e06363576570db625ff984faaa92.png";